import {useMutation} from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';

export default function useBulkImportPgnStatus(
  handleOnSuccess?: (data: any) => void,
  handleOnError?: (data: any) => void,
) {
  return useMutation<any, Error, {gameId: string; importId: string}>(
    async ({gameId, importId}) => {
      const response = await ChessRestClient.get(
        `learning/study_games/${gameId}/bulk_import_pgn/${importId}/status/`,
      );
      return response.data;
    },
    {
      onSuccess: data => {
        handleOnSuccess?.(data);
      },
      onError: error => {
        handleOnError?.(error);
      },
    },
  );
}
